import { render, staticRenderFns } from "./VuesticFileUploadUndo.vue?vue&type=template&id=53639db7"
import script from "./VuesticFileUploadUndo.vue?vue&type=script&lang=js"
export * from "./VuesticFileUploadUndo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53639db7')) {
      api.createRecord('53639db7', component.options)
    } else {
      api.reload('53639db7', component.options)
    }
    module.hot.accept("./VuesticFileUploadUndo.vue?vue&type=template&id=53639db7", function () {
      api.rerender('53639db7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-file-upload/VuesticFileUploadUndo.vue"
export default component.exports